import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const textAreaViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map